
export default class RegisterIndex {

    constructor() {

        this.name = $('#name')
        this.last_name = $('#last_name')
        this.email = $('#email-register')
        this.birthdate = $('#birthdate')
        this.password = $('#password-register')
        this.c_password = $('#password-confirm-register')


        this.events()
        this.onLoad()
    }


    onLoad() {


    }


    events() {
        $('#name').on('change',() => {
            $('#name-error-signup-inner').remove();
        });
        $('#last_name').on('change',() => {
            $('#last_name-error-signup-inner').remove();
        });
        $('#email').on('change',() => {
            $('#email-error-signup-inner').remove();
        });
        $('#birthdate').on('change',() => {
            $('#birthdate-error-signup-inner').remove();
        });

        $("#birthdate").on('change',() => this.calculateAge(this.birthdate.val()) )

    }

    performRegister() {


        if(this.name.val() || this.last_name.val() || this.email.val() || this.birthdate.val() || this.password.val() || this.c_password.val() === ""){
            e.preventDefault();
            if(this.name.val() === ""){
                $('#name-error-signup-inner').remove();
                $('#name-error-signup').append('<div id="name-error-signup-inner">⚠ Name is required</div>')
            }
            if(this.name.val().match(/\d+/g)){
                $('#name-error-signup-inner').remove();
                $('#name-error-signup').append('<div id="name-error-signup-inner">⚠ Name is invalid</div>')
            }
            if(this.last_name.val() === ""){
                $('#last_name-error-signup-inner').remove();
                $('#last-name-error-signup').append('<div id="last-name-error-signup-inner">⚠ Last name is required</div>')
            }
            if(this.email.val() === ""){
                $('#email-error-signup-inner').remove();
                $('#email-error-signup').append('<div id="email-error-signup-inner">⚠ Email is required</div>')
            }
            if(this.birthdate.val() === ""){
                $('#birthdate-error-signup-inner').remove();
                $('#birthdate-error-signup').append('<div id="birthdate-error-signup-inner">⚠ Date of birth is required</div>')
            }
            if(this.password.val() === ""){
                $('#password-error-signup').append('<div id="password-error-signup-inner">⚠ Password is required</div>')
            }
        }

        e.preventDefault();
        axios.post('/register', {
            name:  this.name,
            last_name: this.last_name,
            email:  this.email,
            birthdate:  this.birthdate,
            password: this.password,
            password_confirmation: this.c_password
        },{
           headers: { "X-Requested-With": "XMLHttpRequest" }
        }
        ).then(response => response.json())
      .then(data => {
          console.log(data);
        if (data.errors === undefined) {
          //success
          window.location.replace(data.redirect);
        } else {
          //something went wrong

        }
      })
      .catch(err => console.error(err));
    }


    calculateAge(date){
        let eighteenYears = moment().subtract(18, "years");
        let birthday = moment(new Date(date));
        if (!birthday.isValid()) {

        } else if (eighteenYears.isAfter(birthday)) {
            //delete errors.selectedDate;
            console.log('you are older than 18 years old')
        } else {
            // errors.selectedDate = { message: "Must be 18 or older" };
            console.log('must be older than 18 years old!')
        }
    }

    correctCaptcha() {
        $("form").each(function() {
            $(this).find(':input[type="submit"]').prop('disabled', false);
        });
    }

}
